import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Overlay from "../../../Overlay";
import Button from "../../../common/Button";
import { PAGE_STATE } from "../../../../constants";
import useUsers from "../../../../hooks/useUsers";
import { format } from "date-fns";

import { ReactComponent as CopySvg } from "../../../../assets/icons/copy.svg";

const View = ({ editing: _editing, onClose }) => {
  const [editing] = useState(_editing);
  const [pageState, setPageState] = useState(
    editing ? PAGE_STATE.LOADING : PAGE_STATE.IDLE
  );
  const [initialValues, setInitialValues] = useState({
    uid: "",
    email: "",
    name: "",
    dateOfBirth: "",
    joined: "",
  });
  const [user, setUser] = useState(undefined);
  const { getUser, getPlan, patchUser } = useUsers();

  useEffect(() => {
    if (!editing) {
      setPageState(PAGE_STATE.IDLE);
      return;
    }
    fetchData();
    return () => {};
  }, []);

  const fetchData = async () => {
    const {
      no,
      email,
      firstname,
      surname,
      plan,
      dateOfBirth,
      createdOn,
      active,
    } = await getUser(editing);
    let _dateOfBirth = "-";
    let _plan = {};
    const _joined = format(new Date(createdOn), "dd/MM/yyyy");
    if (dateOfBirth) {
      _dateOfBirth = format(new Date(dateOfBirth), "dd/MM/yyyy");
    }
    if (plan) {
      _plan = await getPlan(plan);
    }

    setUser({
      uid: (no || 1).toString().padStart(6, "0"),
      email,
      name: `${firstname} ${surname}`,
      dateOfBirth: _dateOfBirth || "",
      joined: _joined,
      active,
      plan: _plan?.name || "-",
    });

    setPageState(PAGE_STATE.IDLE);
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  // TODO: Ban and Delete
  const handleBan = () => {};

  const handleDisableClick = async () => {
    await patchUser(_editing, { active: false });
    setUser((curr) => ({ ...curr, active: false }));
  };

  const handleActiveClick = async () => {
    await patchUser(_editing, { active: true });
    setUser((curr) => ({ ...curr, active: true }));
  };

  if (pageState === PAGE_STATE.LOADING) {
    return <Overlay />;
  }

  return (
    <Overlay
      style={{
        alignItems: "flex-start",
      }}
      onClose={onClose}
      content={
        <div className="admin-users-view">
          <h2>Information</h2>
          <div className="admin-users-view-info">
            <span className="admin-users-view-info__title">UID</span>
            <div className="admin-users-view-info-data">
              <CopySvg
                className="admin-users-view-info-data__icon"
                onClick={() => handleCopyToClipboard(user.uid)}
              />
              <span>#{user?.uid}</span>
            </div>
            <span className="admin-users-view-info__title">Name</span>
            <div className="admin-users-view-info-data">
              <CopySvg
                className="admin-users-view-info-data__icon"
                onClick={() => handleCopyToClipboard(user.name)}
              />
              <span>{user?.name}</span>
            </div>
            <span className="admin-users-view-info__title">Email</span>
            <span>{user?.email}</span>
            <span className="admin-users-view-info__title">Plan</span>
            <span>{user?.plan}</span>
            <span className="admin-users-view-info__title">Date of birth</span>
            <span>{user?.dateOfBirth}</span>
            <span className="admin-users-view-info__title">Joined</span>
            <span>{user?.joined}</span>
            <span className="admin-users-view-info__title">Phone number</span>
            <span>{user?.phoneNo || "-"}</span>
            <span className="admin-users-view-info__title">Status</span>
            <span>{user?.active}</span>
          </div>
          <h2>Ban History</h2>
          <div className="admin-users-view-bans"></div>
          <div className="admin-users-view-ctas">
            <Button label={"Ban"} onClick={handleBan} />
            {user?.active ? (
              <Button label={"Disable"} onClick={handleDisableClick} />
            ) : (
              <Button label={"Enable"} onClick={handleActiveClick} />
            )}
          </div>
        </div>
      }
    ></Overlay>
  );
};

View.propTypes = {
  onClose: PropTypes.func,
  editing: PropTypes.string,
};

View.defaultProps = {
  onClose: () => {},
  editing: undefined,
};

export default View;
